import { routeUtil } from '@cmg/common';
import React from 'react';
import { Route, Routes, useMatch } from 'react-router-dom';

import routeFactory from '../../common/util/routeFactory';
import RolodexCrmIntegrationDetailRoute from './crm-integration-detail/RolodexCrmIntegrationDetailRoute';
import RolodexCrmIntegrationListRoute from './crm-integration-list/RolodexCrmIntegrationListRoute';
import { CRMManagementRoute } from './crm-management/CRMManagementRoute';
import RolodexCrmMatchListRoute from './crm-match-list/RolodexCrmMatchListRoute';
import RolodexFirmDetailRoute from './firm-detail/RolodexFirmDetailRoute';
import RolodexFirmListRoute from './firm-list/RolodexFirmListRoute';
import RolodexFirmNewRoute from './firm-new/RolodexFirmNewRoute';
import RolodexSubNavigation from './RolodexSubNavigation';

const rel = (routePath: string) =>
  routeUtil.getRelativeRoutePath(routeFactory.rolodex.routePath, routePath);

export const RolodexRoute: React.FC = () => {
  const isRolodexRoute = useMatch(`${routeFactory.rolodex.routePath}/*`);

  return (
    <React.Fragment>
      {/* Show sub-navigation for all rolodex routes */}
      {isRolodexRoute && <RolodexSubNavigation />}

      <Routes>
        <Route path={rel(routeFactory.rolodexFirms.routePath)} element={<RolodexFirmListRoute />} />
        <Route
          path={rel(routeFactory.rolodexFirmDetail.routePath)}
          element={<RolodexFirmDetailRoute />}
        />
        <Route
          path={`${rel(routeFactory.rolodexFirmNew.routePath)}/*`}
          element={<RolodexFirmNewRoute />}
        />
        <Route
          path={rel(routeFactory.rolodexCrmIntegrations.routePath)}
          element={<RolodexCrmIntegrationListRoute />}
        />
        <Route
          path={rel(routeFactory.rolodexCrmIntegrationDetail.routePath)}
          element={<RolodexCrmIntegrationDetailRoute />}
        />
        <Route
          path={rel(routeFactory.rolodexCrmEntityMatcher.routePath)}
          element={<RolodexCrmMatchListRoute />}
        />
        <Route
          path={rel(routeFactory.rolodexCrmEntityMatcherWithMatchDetails.routePath)}
          element={<RolodexCrmMatchListRoute />}
        />
        <Route
          path={`${rel(routeFactory.sysAdminCrmManagement.routePath)}/*`}
          element={<CRMManagementRoute />}
        />
      </Routes>
    </React.Fragment>
  );
};

export default RolodexRoute;
